export default {
  education: {
    webinar: {
      title: "Register for the event to access the recording",
      text: "You can log in automatically with your current account data or enter the data manually in the next step.",
      label: "By registering, you accept",
      link: "terms of transfer to the MTS Link service partner",
      close: "Enter the data manually",
      submit: "Register",
    },
    metaTitle: "Education",
    noContentLang: "There are no materials published in this language yet",
    titles: {
      material: "Training for doctors",
      course: "Educational courses for doctors",
      simulator: "Simulators for doctors",
      webinar: "Webinars for doctors",
    },
    filters: {
      selects: {
        type: {
          placeholder: "Type of materials",
        },
        lang: {
          placeholder: "Language",
        },
        status: {
          placeholder: "Status",
          values: {
            actual: "Ongoing",
            overpast: "Past",
          },
        },
        specialty: {
          placeholder: "Specialty",
        },
      },
      tabs: {
        material: "All materials",
        course: "Courses",
        simulator: "Simulators",
        webinar: "Webinars",
      },
    },
    content: {
      subtitles: {
        your: {
          material: "Your materials",
          course: "Your courses",
          simulator: "Your simulators",
          webinar: "Your webinars",
        },
        recomended: {
          material: "Recommended materials",
          course: "Recommended courses",
          simulator: "Recommended simulators",
          webinar: "Recommended webinars",
        },
      },
    },
  },
  Lessons: {
    Lesson: {
      title: "Lesson",
      Files: "Applications",
      DownloadAll: "Download all",
    },
    status: {
      success: "Completed",
      unsuccess: "Not Completed",
      stop: "Unavailable",
    },
  },
  Tests: {
    table: {
      tests: "Tests",
      description: "Description",
      points: "Points",
      status: "Status",
    },
    modal: {
      title: "Do you want to finish the test?",
    },
    questions: {
      question: "Question",
      answer: "Answer",
      correct: "Correct",
      incorrect: "Incorrect",
      moderated: "Under review",
      navigation: "Test navigation",
      enterAnswer: "Enter answer...",
    },
    errors: {
      required: "Required question",
    },
    submit: "Finish testing",
    result: "Result",
    repeat: "Retake",
  },
  afterPayCourse: {
    title: "You have successfully purchased the course",
    text: "Now you have access to the training materials",
    buttonText: "Go to the course",
  },
  coursePage: {
    courseType: {
      course: "Course",
      simulator: "Trainer",
      webinar: "Webinar",
    },
    groupNumber: "{n}th stream",
    manager: "Manager",
    curator: "Curator",
    free: "Free",
  },
  coursesPage: {
    materials: "Materials",
    schools: "Author's schools",
    universities: "Universities",
    showPast: "Show past events",
    emptyList: "There are no such materials",
    show: "Show",
    result1: "result",
    result2: "results",
    result5: "results",
    filters: "Filters",
    clear: "Clear",
  },
};
